/* src/app/search/search.component.css */
:host {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  position: relative;
  z-index: 2000;
}
.search-box {
  position: relative;
  width: 100%;
  max-width: 580px;
  padding: 8px 10px;
  background: transparent;
}
.search-row {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
}
.search-input-area {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
}
.search-type-wrap {
  flex: 0 0 220px;
  width: 220px;
}
.search-input-area {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
}
.search-input {
  width: 100%;
  height: 46px;
  padding: 0 12px;
  border: 1px solid #bfc5cc;
  background: #fff;
  font-size: 16px;
  box-sizing: border-box;
  border-radius: 4px;
}
.search-input:focus {
  outline: none;
  border-color: #5b8def;
}
.search-double-input {
  display: flex;
  gap: 8px;
  width: 100%;
}
.search-double-input .search-input {
  flex: 1 1 0;
}
.search-dropdown {
  position: absolute;
  top: 46px;
  left: 0;
  width: 100%;
  max-width: 650px;
  max-height: 360px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #d8dde3;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 3000;
  border-radius: 4px;
}
:host ::ng-deep .search-type-wrap .p-select {
  width: 100%;
  max-width: 220px;
  min-height: 42px;
}
:host ::ng-deep .search-type-wrap .p-select-label {
  display: flex;
  align-items: center;
  min-height: 42px;
}
:host ::ng-deep .search-type-wrap .p-select-trigger {
  width: 42px;
}
.search-item {
  padding: 10px 12px;
  cursor: pointer;
  border-bottom: 1px solid #eef1f4;
}
.search-item:last-child {
  border-bottom: none;
}
.search-item:hover {
  background: #f6f8fa;
}
.search-item-title {
  font-size: 15px;
  font-weight: 600;
  color: #222;
  line-height: 1.3;
}
.search-item-subtitle {
  margin-top: 4px;
  font-size: 13px;
  color: #666;
}
.search-item-detailed div {
  margin-bottom: 4px;
  font-size: 14px;
  color: #222;
}
.search-item-detailed div:last-child {
  margin-bottom: 0;
}
:host ::ng-deep .search-type-wrap .p-select {
  width: 100%;
  max-width: 220px;
  min-height: 42px;
}
:host ::ng-deep .search-type-wrap .p-select-label {
  display: flex;
  align-items: center;
  min-height: 42px;
}
:host ::ng-deep .search-type-wrap .p-select-trigger {
  width: 42px;
}
body .p-select-panel .p-select-item:not(.p-disabled):hover {
  background: #e3e3e3 !important;
  color: #000 !important;
}
body .p-select-panel .p-select-item.p-focus,
body .p-select-panel .p-select-item:focus {
  background: #e3e3e3 !important;
  color: #000 !important;
  box-shadow: none !important;
  outline: none !important;
}
body .p-select-panel .p-select-item.p-highlight,
body .p-select-panel [aria-selected=true] {
  background: #e6e6e6 !important;
  color: #333 !important;
}
@media (max-width: 900px) {
  .search-row {
    flex-direction: column;
  }
  .search-type-wrap {
    flex: 0 0 auto;
    width: 100%;
  }
  .search-input-area {
    width: 100%;
  }
  .search-double-input {
    flex-direction: column;
  }
}
/*# sourceMappingURL=search.component.css.map */
